import {
  initialState,
  Actions,
  State,
  EDIT_CUSTOMER_RESPONSIBLES,
  EDIT_CUSTOMER_RESPONSIBLES_SUCCESS,
  EDIT_CUSTOMER_RESPONSIBLES_ERROR,
  RESET_EDIT_CUSTOMER_RESPONSIBLES,
} from '../../types/customer/edit-customer-responsibles'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_CUSTOMER_RESPONSIBLES:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case EDIT_CUSTOMER_RESPONSIBLES_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case EDIT_CUSTOMER_RESPONSIBLES_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      }
    case RESET_EDIT_CUSTOMER_RESPONSIBLES:
      return initialState
    default:
      return state
  }
}

export default reducers
